// extracted by mini-css-extract-plugin
export default {"Video":"AutoPlayVideo-module__Video--Uhsrg","PlayButton":"AutoPlayVideo-module__PlayButton--p4Dp5"};